import ct from "class-types.macro";
import React from "react";
import connectUserAndChat, { User } from "../Store/connectUserAndChat";

interface Props {
  user: User;
}

export default connectUserAndChat(function HelpCartId({ user }: Props) {
  return (
    <div className="help__block help__block--cart cart-id">
      <p className="help__small">
        Use this number when contacting
        <br />
        customer service about cart issues:
      </p>
      <p className="help__subject help__subject--cart">
        Your Cart ID:&nbsp;
        <span className={ct("font-bold")} id="cart_reference_code">
          {user.cartCode}
        </span>
      </p>
    </div>
  );
});
